import style from "../../calculator.module.css";
import { ContextCalculatorUser } from "../../../../context/ContextCalculatorUser";
import { Context } from "../../../../App";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { TooltipError } from "../../widgets/TooltipError";
import { useState, useContext } from "react";
import { generateLinkSpreadsheet } from "../../../../utils/calculator/spreadsheet";

function Mobile(props) {
  const {
    profitSurebet,
    selectedBookmaker,
    setSelectedBookmaker,
    budget,
    roundingEnabled,
    roundTo,
    showCommission,
    setShowCommission,
    editingValues,
    editingRoundTo,
    setEditingValues,
  } = ContextCalculatorUser();
  const { statusMode, buttonSpreadsheet } = useContext(Context);
  const {
    dataOperation,
    formData,
    typeSurebet,
    handleStakeChange,
    calculateSurebet,
    helperInputChance,
    helperInputStake,
    helperInputBackStake,
    helperInputCommission,
    helperInputBudget,
    helperInputRound,
    isBlockedFieldsCash,
    manageEventInputRoundingEnabled,
  } = props;
  const [isClosedRound, setIsClosedRound] = useState(true);
  const indexBookmakerBonus = 0;
  return (
    <div>
      <style>{`
        
        :root{
        ${
          statusMode === true
            ? `
          --bg: #0f1115;
          --surface: #15181e;
          --surface-2: #10141a;
          --text: #e6e8ee;
          --muted: #a3adbd;
          --brand: #2a960d; 
          --accent: #00d68f;
          --border: #232833;
          --radius: 14px;

          
          --s-2:.5rem; --s-3:.75rem; --s-4:1rem; --s-5:1.25rem; --s-6:1.5rem; --s-8:2rem; --s-10:2.5rem;
          --fs-90: clamp(.82rem,.78rem + .2vw,.92rem);
          --fs-100: clamp(.95rem,.9rem + .25vw,1.05rem);
          --fs-200: clamp(1.05rem,1rem + .35vw,1.2rem);
          --fs-400: clamp(1.2rem,1.1rem + .6vw,1.5rem);
          --fs-700: clamp(1.6rem,1.3rem + 1.6vw,2.2rem);
          --fs-900: clamp(2rem,1.5rem + 3vw,3rem);`
            : `
        --bg: #f7f9fc;
        --surface: #ffffff;
        --surface-2: #f2f4f8;
        --text: #1a1f2b;
        --muted: #5b667a;
        --brand: #2a960d; 
        --accent: #00d68f;
        --border: #d9dfe7;
        --radius: 14px;

        
        --s-2:.5rem; --s-3:.75rem; --s-4:1rem; --s-5:1.25rem; --s-6:1.5rem; --s-8:2rem; --s-10:2.5rem;
        --fs-90: clamp(.82rem,.78rem + .2vw,.92rem);
        --fs-100: clamp(.95rem,.9rem + .25vw,1.05rem);
        --fs-200: clamp(1.05rem,1rem + .35vw,1.2rem);
        --fs-400: clamp(1.2rem,1.1rem + .6vw,1.5rem);
        --fs-700: clamp(1.6rem,1.3rem + 1.6vw,2.2rem);
        --fs-900: clamp(2rem,1.5rem + 3vw,3rem);
        `
        }
        }

        *{box-sizing:border-box}
        html,body{height:100%}
        body{
          margin:0;
          font: 500 var(--fs-100)/1.6 ui-sans-serif, system-ui, -apple-system, Segoe UI, Inter, Roboto, Arial, sans-serif;
          background:var(--bg)!important;
          color:var(--text);
          -webkit-font-smoothing:antialiased; text-rendering:optimizeLegibility;
        }

        
        

        .wrap{max-width:720px; margin:0 auto; padding: min(6vw,48px); padding-top: 3vw;}

        
        .head{
          display:grid; grid-template-columns:1fr auto; gap:12px; align-items:start;
          
        }
        .head h2{margin:0; font-size:var(--fs-700); font-weight:800}
        .head p{margin:8px 0 0; color:var(--muted); font-size:var(--fs-100)}
        .percent{ color:${statusMode === true ? `var(--accent)` : "#2a960d"}; }
        .fs-percent{font-size:var(--fs-700); font-weight:900; align-self:center;}
        
        .card{padding:28px 0; border: none; border-radius: 0; border-bottom:1px solid var(--border); background:var(--bg);}
        .book-title{font-size:clamp(24px,6vw,32px); font-weight:800; margin:0 0 2px; color:var(--text);}
        .subtitle{color:var(--muted); margin:0; display:flex; align-items:center; gap:8px}
        .hint{display:inline-grid; place-items:center; width:22px; height:22px; border-radius:50%; border:1.6px solid var(--text); font-size:14px; font-weight:700}

        .row{display:grid; grid-template-columns:1fr 1.5fr 1.5fr; margin-top:26px; gap: 10px}
        .row *{
        padding:0;
        }
        .col{min-width:0}
        .label{font-weight:800; font-size: 16px); margin-bottom:10px; color:var(--text)}

        .field{position:relative}
        .input{
          width:100%; padding:16px 18px; font-size:var(--fs-200); font-weight:800; color:var(--text);
          background:var(--surface-2); border:1.5px solid var(--border); border-radius:var(--radius); outline:none;
        }
        .input:focus{ box-shadow:0 0 0 2px color-mix(in srgb, var(--brand) 55%, transparent); border-color:color-mix(in srgb, var(--brand) 70%, var(--border)); }

        .pill{
          display:inline-block; padding:16px 18px; font-weight:800; border:1.5px solid var(--border); border-radius:var(--radius);
          background:var(--surface-2);
          color:var(--text);
          font-size: clamp(1.05rem,1rem + .35vw,1.2rem);
        }
        .input.green{ background:var(--accent); border-color:var(--accent); color:#002b1e; }

        
        .total{ text-align:center; padding:36px 0 }
        .total .c-title{font-weight:800; font-size:var(--fs-400); margin-bottom:16px}
        .total .input{ max-width:260px; margin:0 auto; display:block }

        
        .bottombar{
          position:sticky; bottom:0; left:0; right:0;
          border:1.5px solid var(--border); border-radius:18px; margin-top:24px;
          display:flex; align-items:center; gap:14px; padding:16px; background:var(--surface);
        }
        .checkbox{appearance:none; width:28px; height:28px; border:1.5px solid var(--border); background:var(--surface-2); border-radius:4px; display:inline-block; position:relative;}
        .checkbox:checked::after{content:""; position:absolute; inset:5px; background:var(--accent); border-radius:2px}
        .bottombar label{font-weight:800; font-size:var(--fs-100)}
        .bottombar .small{width:70px; text-align:center; padding:10px 12px; font-size:var(--fs-200); background:var(--surface-2); border:1.5px solid var(--border); border-radius:10px; color:var(--text)}

        .commission{display:flex; align-items:center; gap:14px; background:var(--surface);}
        .commission label{font-weight:800; font-size:var(--fs-100)}
        .commission .small{width:70px; text-align:center; padding:10px 12px; font-size:var(--fs-200); background:var(--surface-2); border:1.5px solid var(--border); border-radius:10px; color:var(--text)}
        
        
          .z_index_tooltip{z-index: 1;}
      `}</style>

      <main className="wrap" role="main">
        <header
          className="head"
          aria-label="Resumo"
          style={{ boxShadow: "none" }}
        >
          <div>
            <h2>{formData["title"]}</h2>
            <p>{formData["sub_title"]}</p>
          </div>
          <div className="d-flex flex-column align-items-end">
            {typeSurebet !== "bonus_bookmaker" &&
              typeSurebet !== "risk_free_betting" && (
                <div
                  className={`fs-percent ${profitSurebet > 0 ? "percent" : profitSurebet < 0 ? "text-danger" : statusMode ? `${style.calculator_text_dark_mode}` : ""}`}
                >
                  {profitSurebet > 0 ? "+" : ""}
                  {profitSurebet.toFixed(2)}%
                </div>
              )}
            {buttonSpreadsheet === true && (
              <div>
                <button
                  className={`spreadsheet-btn-add ${!statusMode ? "spreadsheet-btn-bg-light" : ""}`}
                  onClick={() => {
                    generateLinkSpreadsheet(
                      dataOperation,
                      formData,
                      typeSurebet,
                    );
                  }}
                >
                  <span className="spreadsheet-btn-icon">+</span>
                  Adicionar à <br /> Planilha
                </button>
              </div>
            )}
          </div>
        </header>
        <Tooltip id="calculator-mobile-tooltip" className="z_index_tooltip" />

        {dataOperation.map((operation, index) => {
          let blockPerMode =
            (typeSurebet === "bonus_bookmaker" &&
              indexBookmakerBonus !== index) ||
            (typeSurebet === "risk_free_betting" &&
              indexBookmakerBonus !== index) ||
            (typeSurebet === "locked_value" && index > 1);
          return (
            <section
              className="card"
              aria-labelledby={operation.bet_home_name.toLowerCase()}
              key={index}
            >
              <h3 className="book-title name-bet-home">
                {operation.bet_home_name}
              </h3>
              <p className="subtitle">
                {operation.market_event}
                <span
                  className="hint"
                  aria-hidden="true"
                  data-tooltip-id="calculator-mobile-tooltip"
                  data-tooltip-content={operation.info_market_event}
                >
                  ?
                </span>
              </p>

              <div className="row">
                <div className="col">
                  <div>
                    <div className="label">Chance</div>
                    <div className="field position-relative">
                      {operation.chance < 1 && <TooltipError />}

                      <input
                        type="text"
                        className={`input ${operation.chance < 1 ? style.calculator_input_value_invalid : ""}`}
                        placeholder="0.00"
                        disabled={operation.block_chance}
                        value={
                          editingValues[`${index}-chance`] !== undefined
                            ? String(editingValues[`${index}-chance`]).replace(
                                ".",
                                ",",
                              )
                            : String(operation.chance).replace(".", ",")
                        }
                        onChange={(e) => {
                          helperInputChance(e, index, operation);
                        }}
                      />
                    </div>
                  </div>
                  {showCommission === true && (
                    <div>
                      <div className="label">Comissão</div>
                      <div className="field position-relative">
                        {operation.commission < -40 && <TooltipError />}
                        <input
                          type="text"
                          className={`input ${operation.commission < -40 ? style.calculator_input_value_invalid : ""}`}
                          placeholder="0.00"
                          value={
                            editingValues[`${index}-commission`] !== undefined
                              ? String(
                                  editingValues[`${index}-commission`],
                                ).replace(".", ",")
                              : String(operation.commission).replace(".", ",")
                          }
                          onChange={(e) => {
                            helperInputCommission(e, index, operation);
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="col position-relative">
                  <div className="label">Aposta</div>
                  <div className="field position-relative">
                    {((operation.stake < 0 && budget > 0) ||
                      (editingValues[`${index}-stake`] !== undefined &&
                        editingValues[`${index}-stake`].length === 0)) && (
                      <TooltipError />
                    )}
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        className={`input ${(operation.stake < 0 && budget > 0) || (editingValues[`${index}-stake`] !== undefined && editingValues[`${index}-stake`].length === 0) ? style.calculator_input_value_invalid : ""}
                          ${typeSurebet === "bonus_bookmaker" && indexBookmakerBonus === index ? `border border-2  ${style.calculator_border_bonus_surebet}` : ""}
                          `}
                        disabled={
                          operation.block_stake ||
                          blockPerMode ||
                          (isBlockedFieldsCash && index !== selectedBookmaker)
                        }
                        value={
                          editingValues[`${index}-stake`] !== undefined
                            ? String(editingValues[`${index}-stake`]).replace(
                                ".",
                                ",",
                              )
                            : String(operation.stake).replace(".", ",")
                        }
                        onChange={(e) => {
                          helperInputStake(e, index, operation);
                        }}
                      />
                      {typeSurebet !== "bonus_bookmaker" &&
                        typeSurebet !== "risk_free_betting" &&
                        typeSurebet !== "locked_value" &&
                        isBlockedFieldsCash === false && (
                          <input
                            className="form-check-input d-block ms-2"
                            type="radio"
                            name="flexRadioDefault"
                            id="checker_first_home_bet"
                            checked={selectedBookmaker === index}
                            onChange={() => {
                              setEditingValues({});
                              setSelectedBookmaker(index);
                              handleStakeChange(index, operation.stake, true);
                            }}
                          />
                        )}
                    </div>

                    {operation.market_event
                      .toLowerCase()
                      .includes("lay (contra)") && (
                      <div>
                        <div className="label" style={{ textWrap: "nowrap" }}>
                          Responsabilidade
                        </div>

                        <input
                          type="text"
                          className={`input green w-50 px-2 ${operation.backStake < 0 && budget > 0 ? style.calculator_input_value_invalid : ""}
                            ${typeSurebet === "bonus_bookmaker" && indexBookmakerBonus === index ? `border border-2  ${style.calculator_border_bonus_surebet}` : ""}
                            `}
                          disabled={
                            operation.block_stake ||
                            blockPerMode ||
                            (isBlockedFieldsCash && index !== selectedBookmaker)
                          }
                          value={
                            editingValues[`${index}-backStake`] !== undefined
                              ? String(
                                  editingValues[`${index}-backStake`],
                                ).replace(".", ",")
                              : String(operation.backStake).replace(".", ",")
                          }
                          onChange={(e) => {
                            helperInputBackStake(e, index);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="col">
                  <div>
                    <div className="label">Lucro</div>
                    <div
                      className="pill w-75"
                      data-tooltip-id="calculator-mobile-tooltip"
                      data-tooltip-content={operation.profit.toFixed(2)}
                    >
                      {operation.profit !== undefined
                        ? isNaN(operation.profit)
                          ? "Erro"
                          : operation.profit.toFixed(2).length > 9
                            ? operation.profit.toString().slice(0, 7) + "..."
                            : operation.profit.toFixed(2)
                        : "0.00"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row" style={{ marginTop: 18 }}>
                <div className="col"></div>
                <div className="col"></div>
              </div>
            </section>
          );
        })}

        <section className="total position-relative" aria-labelledby="total">
          {budget < 0 && <TooltipError />}

          <div id="total" className="c-title">
            Valor total
          </div>

          <div className="d-inline-flex align-items-center">
            <input
              type="text"
              disabled={
                typeSurebet === "bonus_bookmaker" ||
                typeSurebet === "risk_free_betting" ||
                typeSurebet === "locked_value" ||
                isBlockedFieldsCash
              }
              className={`input ${budget < 0 ? style.calculator_input_value_invalid : ""}`}
              placeholder="R$ 0.00"
              value={
                editingValues[`-999-budget`] !== undefined
                  ? String(editingValues[`-999-budget`]).replace(".", ",")
                  : String(budget).replace(".", ",")
              }
              onChange={(e) => {
                helperInputBudget(e);
              }}
            />
            {typeSurebet !== "bonus_bookmaker" &&
              typeSurebet !== "risk_free_betting" &&
              typeSurebet !== "locked_value" &&
              isBlockedFieldsCash === false && (
                <input
                  className="form-check-input d-block ms-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="checker_total"
                  checked={selectedBookmaker === -999}
                  onChange={() => {
                    setEditingValues({});
                    setSelectedBookmaker(-999);
                    calculateSurebet();
                  }}
                />
              )}
          </div>
        </section>

        <section
          className="bottombar position-relative"
          role="region"
          aria-label="Arredondamento"
        >
          <input
            className="checkbox"
            type="checkbox"
            id="commission-active"
            checked={showCommission}
            onChange={() => setShowCommission(!showCommission)}
            style={{ minHeight: "15px", minWidth: "15px" }}
          />
          <label
            className="form-check-label p-0 ms-2 text-color-dark-mode"
            htmlFor="commission-active"
          >
            Mostrar comissões
          </label>
        </section>

        <section
          className={`bottombar ${isClosedRound === true ? "position-relative" : ""}`}
          role="region"
          aria-label="Arredondamento"
        >
          <div className="position-relative commission flex-wrap">
            {roundTo <= 0 && <TooltipError />}
            <div className="d-flex align-items-center" style={{ gap: "14px" }}>
              <div>
                <input
                  className="checkbox"
                  type="checkbox"
                  id="chk"
                  checked={roundingEnabled}
                  onChange={manageEventInputRoundingEnabled}
                  aria-label="Ativar arredondamento"
                />
              </div>

              <label htmlFor="chk">Arredondar apostas até:</label>
              <input
                type="text"
                className={`small ${roundTo < 0 ? style.calculator_input_value_invalid : ""}    `}
                placeholder="0,00"
                value={
                  editingRoundTo !== undefined
                    ? String(editingRoundTo).replace(".", ",")
                    : String(roundTo).replace(".", ",")
                }
                onChange={(e) => {
                  helperInputRound(e);
                }}
                disabled={!roundingEnabled}
                aria-label="Arredondar até"
              />
            </div>

            <div className="d-flex align-items-center" style={{ gap: "14px" }}>
              <input
                className="checkbox"
                type="checkbox"
                id="xxxo"
                onChange={() => {
                  setIsClosedRound(!isClosedRound);
                }}
              />

              <label htmlFor="xxxo">
                {!isClosedRound === true ? "Minimizar" : "Fixar"}
              </label>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
export { Mobile as default };
